import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ValidationError } from '@dma/shared';
import type { ScientificEntryRepository } from '../../domain/repositories/ScientificEntryRepository.interface';
import type { ScientificEntryDto } from '../dto/ScientificEntryDto';

export class GetScientificEntryByIdUseCase {
  constructor(private readonly repository: ScientificEntryRepository) {}

  public async execute(actingUser: AuthorizedUser | null, id: string): Promise<ScientificEntryDto> {
    if (!can(actingUser, 'scientific-entry:manage')) {
      throw new AuthorizationError();
    }

    const entry = await this.repository.getById(id);
    if (!entry) {
      throw new ValidationError(`مطلبی با شناسه‌ی "${id}" یافت نشد.`);
    }
    return entry.props;
  }
}
